import $ from 'jquery';
import Hammer from 'hammerjs';
import Page from '../Page/_State';

let insans;

class SekaiSen {
  constructor(target) {
    this.target = $(target);
    this.body = $('body');
    this.pageDefault = $('.page-default');
    this.isSekaisen = false; //世界線表示中か
    this.tobiraIndex = 0;
    this.slideMaxNum = 5;
    // this.slideMaxNum = 1;
    // this.classNameNavOpen = 'nav--open';
    this.classNameBodyOverFlowHidden = 'over-flow--hidden';
    this.classNameOpen = 'sekai-tobira--open';
    // this.classNameOpenSekaiSen = 'page-sekai-sen--open';
    // this.classNameOpenSekaiSenHiden = 'page-sekai-sen--hide';
    this.btnOpen = $('.sekai-top .sekai-top-c2-btn');
    this.pageSekaiSen = $('.page-sekai-sen');
    // this.nav = $('.nav');
    this.tobiraW = this.target.outerWidth(true);
    this.tobiraLi = this.target.find('.sekai-img');
    this.nextBtn = this.target.find('.sekai-img-btn a');

    this._setOpenBtn();
    this._setTobira();
    this._setNextBtn();
    this._setSwipeEvent();
  }

  _isSekaisen(flg) {
    // 世界線表示
    if (flg) {
      this.target.addClass(this.classNameOpen);
      // this.body.addClass('body-anc-bottom');
      this._tobiraOpenInit();
    } else {
      // this.body.removeClass('body-anc-bottom');
      this._setTobiraReset();
    }
  }

  _setOpenBtn() {
    this.btnOpen.click(
      function () {
        this._setTobiraReset();
        this._isSekaisen(true);
        return false;
      }.bind(this),
    );
  }

  _tobiraOpenInit() {
    setTimeout(
      function () {
        this.body.addClass(this.classNameBodyOverFlowHidden);
        // this.nav.removeClass(this.classNameNavOpen);
        //iphoneXの下バーを非表示にするため 強制的に下スクロールしてみる
        // $('body,html').animate({ scrollTop: $(window).scrollTop() + 100 }, 500);
      }.bind(this),
      1000,
    );
  }

  _setTobira() {
    let parent = this;
    this.tobiraLi.width(this.contentsW);
    this.tobiraLi.each(function (i) {
      $(this).css('left', parent.tobiraW * i);
    });
  }

  _setNextBtn() {
    this.nextBtn.click(
      function () {
        this._setNextAnim();
        return false;
      }.bind(this),
    );
  }

  _setNextAnim(type) {
    let parent = this;
    let speed;
    let easeType;
    this.tobiraIndex++;

    if (type == 'swipe') {
      speed = 0.5;
      easeType = Power4.out;
    } else {
      speed = 2;
      easeType = Expo.easeInOut;
    }

    TweenMax.to('.sekai-scroll', speed, {
      x: this.tobiraIndex * -this.tobiraW,
      ease: easeType,
      onStart: function () {
        Page.ins.goTo('sekaisen-tobira');
        // 最終スライド完了
        if (parent.slideMaxNum <= parent.tobiraIndex) {
          // parent.pageSekaiSen.removeClass(parent.classNameOpenSekaiSenHiden);
          // parent.pageSekaiSen.addClass(parent.classNameOpenSekaiSen);
          // スライドし終わった後の初期３コマアニメーション
          parent._setYumeInitAnim();
          $(window).scrollTop($('#anc-sekai-sen').offset().top);
        }
      },
      onComplete: function () {
        // 最終スライド完了
        if (parent.slideMaxNum == parent.tobiraIndex) {
          Page.ins.goTo('sekaisen');
          parent._setTobiraReset();
        }
      },
    });
  }

  _setTobiraReset() {
    this.tobiraIndex = 0;
    TweenMax.set('.sekai-scroll', { transform: 'matrix(1, 0, 0, 1, 0, 0)' });
    this.target.removeClass(this.classNameOpen);
  }

  _setYumeInitAnim() {
    let yumeKoma = this.pageSekaiSen.find('.sekai-yume');
    let duration = 4;
    $('body').removeClass(this.classNameBodyOverFlowHidden);
    // TweenMax.set('.sekai-yume-koma4', { opacity: 0 });
    // TweenMax.fromTo(yumeKoma.find('.sekai-yume-koma1'), duration,{opacity: 0},{opacity: 1, ease: Expo.easeOut, delay : 2.3});
    TweenMax.fromTo(yumeKoma.find('.sekai-yume-koma2'), duration,{opacity: 0},{opacity: 1, ease: Expo.easeOut, delay : 2.0});
    TweenMax.fromTo(yumeKoma.find('.sekai-yume-koma3'), duration,{opacity: 0},{opacity: 1, ease: Expo.easeOut, delay : 2.3});
    TweenMax.fromTo('.sekai-yume-koma4 .sekai-yume-img', duration,{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Power4.easeOut, delay : 2.6});
    TweenMax.fromTo('.sekai-yume-koma4 .sekai-yume-txt', duration,{opacity: 0, x: -100},{opacity: 1, x: 0, ease: Power4.easeOut, delay : 2.9});


  }

  _setSwipeEvent() {
    let mc = new Hammer(this.target[0]);
    mc.on(
      'swipeleft swiperight',
      function (ev) {
        if (ev.type == 'swipeleft') this._setNextAnim('swipe');
      }.bind(this),
    );
  }
}

(() => {
  let targets = document.querySelectorAll('.sekai-tobira');
  if (!targets.length) return;
  targets.forEach((item) => {
    insans = new SekaiSen(item);
  });
})();

export default { insans };
